import React from "react";
import StemPlayer from "./StemPlayer";
import "./stemPlayer.css";   // <-- this is the important part

function App() {
  return (
    <div className="App">
      <StemPlayer />
    </div>
  );
}

export default App;
